export const RESOURCE_TYPES = {
    BOOKING: "booking",
    SURVEY: "survey",
    NOTE: "note",
    DOCUMENT: "document",
    SERVICE: "service", // A service is the billable entity derived from a booking.
};
export var INVOICE_ITEM_CHARGE_TYPE;
(function (INVOICE_ITEM_CHARGE_TYPE) {
    INVOICE_ITEM_CHARGE_TYPE["SERVICE_CHARGE"] = "SERVICE_CHARGE";
    INVOICE_ITEM_CHARGE_TYPE["ADD_ON_CHARGE"] = "ADD_ON_CHARGE";
    INVOICE_ITEM_CHARGE_TYPE["CANCELLATION"] = "CANCELLATION";
    INVOICE_ITEM_CHARGE_TYPE["SURVEY_CHARGE"] = "SURVEY_CHARGE";
})(INVOICE_ITEM_CHARGE_TYPE || (INVOICE_ITEM_CHARGE_TYPE = {}));
export var VARIANT_PRICING_TYPE;
(function (VARIANT_PRICING_TYPE) {
    VARIANT_PRICING_TYPE["DEFAULT"] = "default";
    VARIANT_PRICING_TYPE["REGIONAL"] = "regional";
    VARIANT_PRICING_TYPE["AFFILIATE"] = "affiliate";
})(VARIANT_PRICING_TYPE || (VARIANT_PRICING_TYPE = {}));
// Generic Resource
// e.g. Booking is generics of service, survey, add-on charge
export var INVOICE_SECTION_ITEM_LINKABLE_TYPE;
(function (INVOICE_SECTION_ITEM_LINKABLE_TYPE) {
    INVOICE_SECTION_ITEM_LINKABLE_TYPE["BOOKING"] = "booking";
    INVOICE_SECTION_ITEM_LINKABLE_TYPE["SURVEY"] = "survey";
    INVOICE_SECTION_ITEM_LINKABLE_TYPE["SURVEY_ANSWER"] = "surveyAnswer";
    INVOICE_SECTION_ITEM_LINKABLE_TYPE["NOTE"] = "note";
    INVOICE_SECTION_ITEM_LINKABLE_TYPE["DOCUMENT"] = "document";
})(INVOICE_SECTION_ITEM_LINKABLE_TYPE || (INVOICE_SECTION_ITEM_LINKABLE_TYPE = {}));
// Specific Resource Types for Invoice Section Items
export var INVOICE_SECTION_ITEM_RESOURCE_TYPE;
(function (INVOICE_SECTION_ITEM_RESOURCE_TYPE) {
    INVOICE_SECTION_ITEM_RESOURCE_TYPE["SERVICE"] = "service";
    INVOICE_SECTION_ITEM_RESOURCE_TYPE["SURVEY"] = "survey";
    INVOICE_SECTION_ITEM_RESOURCE_TYPE["DOCUMENT"] = "document";
    INVOICE_SECTION_ITEM_RESOURCE_TYPE["NOTE"] = "note";
    INVOICE_SECTION_ITEM_RESOURCE_TYPE["QUESTION_RESPONSE_OPTION"] = "questionResponseOption";
    INVOICE_SECTION_ITEM_RESOURCE_TYPE["ADD_ON_CHARGE"] = "addOnCharge";
    INVOICE_SECTION_ITEM_RESOURCE_TYPE["CHARGE"] = "charge";
    INVOICE_SECTION_ITEM_RESOURCE_TYPE["CUSTOM"] = "custom";
})(INVOICE_SECTION_ITEM_RESOURCE_TYPE || (INVOICE_SECTION_ITEM_RESOURCE_TYPE = {}));
export var BOOKING_CHARGES_SCOPE;
(function (BOOKING_CHARGES_SCOPE) {
    BOOKING_CHARGES_SCOPE["ALL"] = "all";
    BOOKING_CHARGES_SCOPE["SERVICE"] = "service";
})(BOOKING_CHARGES_SCOPE || (BOOKING_CHARGES_SCOPE = {}));
export const INVOICE_SECTION_ITEM_RESOURCE_TYPE_DISPLAY_NAMES = {
    [INVOICE_SECTION_ITEM_RESOURCE_TYPE.SERVICE]: "Service",
    [INVOICE_SECTION_ITEM_RESOURCE_TYPE.SURVEY]: "Survey",
    [INVOICE_SECTION_ITEM_RESOURCE_TYPE.DOCUMENT]: "Document",
    [INVOICE_SECTION_ITEM_RESOURCE_TYPE.NOTE]: "Note",
    [INVOICE_SECTION_ITEM_RESOURCE_TYPE.QUESTION_RESPONSE_OPTION]: "Question Response Option",
    [INVOICE_SECTION_ITEM_RESOURCE_TYPE.ADD_ON_CHARGE]: "Add-on Charge",
    [INVOICE_SECTION_ITEM_RESOURCE_TYPE.CHARGE]: "Charge",
    [INVOICE_SECTION_ITEM_RESOURCE_TYPE.CUSTOM]: "Custom Item",
};
export var TAX_MODE_KEYS;
(function (TAX_MODE_KEYS) {
    TAX_MODE_KEYS["NO_TAX"] = "NO_TAX";
    TAX_MODE_KEYS["EXCLUSIVE"] = "EXCLUSIVE";
    TAX_MODE_KEYS["INCLUSIVE"] = "INCLUSIVE";
})(TAX_MODE_KEYS || (TAX_MODE_KEYS = {}));
export const TAX_MODES = {
    [TAX_MODE_KEYS.NO_TAX]: {
        id: TAX_MODE_KEYS.NO_TAX,
        label: "No tax",
    },
    [TAX_MODE_KEYS.EXCLUSIVE]: {
        id: TAX_MODE_KEYS.EXCLUSIVE,
        label: "Tax exclusive",
        abbreviation: "Excl.",
    },
    [TAX_MODE_KEYS.INCLUSIVE]: {
        id: TAX_MODE_KEYS.INCLUSIVE,
        label: "Tax inclusive",
        abbreviation: "Incl.",
    },
};
export const ASSOCIABLE_RESOURCES = {
    [INVOICE_SECTION_ITEM_LINKABLE_TYPE.BOOKING]: {
        label: "Booking",
        endpoint: "bookings/autocomplete?include=billings",
        getOptionLabel: (option) => `Booking #${option.id} - ${option.date}`,
    },
    [INVOICE_SECTION_ITEM_LINKABLE_TYPE.SURVEY]: {
        label: "Survey",
        endpoint: "surveys/autocomplete?include=billings",
        getOptionLabel: (option) => option.name,
    },
    [INVOICE_SECTION_ITEM_LINKABLE_TYPE.NOTE]: {
        label: "Note",
        endpoint: "respondent-notes/autocomplete?include=billings",
        getOptionLabel: (option) => option.title,
    },
    [INVOICE_SECTION_ITEM_LINKABLE_TYPE.DOCUMENT]: {
        label: "Document",
        endpoint: "respondent-documents/autocomplete?include=billings",
        getOptionLabel: (option) => option.url.split("/").pop() || "",
    },
};
//# sourceMappingURL=invoicing-and-payments.js.map